import { render, staticRenderFns } from "./navAdmin.vue?vue&type=template&id=4191da52&scoped=true&"
import script from "./navAdmin.vue?vue&type=script&lang=js&"
export * from "./navAdmin.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/navAdmin.css?vue&type=style&index=0&id=4191da52&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4191da52",
  null
  
)

export default component.exports